import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_2 = { class: "mb-2" }
const _hoisted_3 = { class: "p-field-radiobutton" }
const _hoisted_4 = { for: "ExternalSensorType.Bticino" }
const _hoisted_5 = { class: "p-field-radiobutton" }
const _hoisted_6 = { for: "ExternalSensorType.VantageSensor" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RadioButton = _resolveComponent("RadioButton")

  return (_openBlock(), _createBlock("div", null, [
    (_ctx.preferenceLabel)
      ? (_openBlock(), _createBlock("h1", _hoisted_1, _toDisplayString(_ctx.preferenceLabel), 1))
      : _createCommentVNode("", true),
    _createVNode("h5", _hoisted_2, _toDisplayString(_ctx.$t("AppResource.TypeOfSensorUpper")), 1),
    _createVNode("div", _hoisted_3, [
      _createVNode(_component_RadioButton, {
        id: "ExternalSensorType.Bticino",
        name: "ExternalSensorType.Bticino",
        value: _ctx.ExternalSensorType.Bticino,
        modelValue: _ctx.roomObject.externalSensorType,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.roomObject.externalSensorType = $event)),
        disabled: _ctx.readOnly
      }, null, 8, ["value", "modelValue", "disabled"]),
      _createVNode("label", _hoisted_4, _toDisplayString(_ctx.$t("AppResource.BticinoSensor")), 1)
    ]),
    _createVNode("div", _hoisted_5, [
      _createVNode(_component_RadioButton, {
        id: "ExternalSensorType.VantageSensor",
        name: "ExternalSensorType.VantageSensor",
        value: _ctx.ExternalSensorType.VantageSensor,
        modelValue: _ctx.roomObject.externalSensorType,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.roomObject.externalSensorType = $event)),
        disabled: _ctx.readOnly
      }, null, 8, ["value", "modelValue", "disabled"]),
      _createVNode("label", _hoisted_6, _toDisplayString(_ctx.$t("AppResource.VantageSensor")), 1)
    ])
  ]))
}